export class InconsistentCollection extends Error {
  static expectedInstanceOf(collectionName, expectedInstance, actualInstance) {
    return new this(`Expected instance of ${expectedInstance.name} in ${collectionName.name}, got ${typeof actualInstance} (${actualInstance.constructor.name}) instead`);
  }
}
